import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import TablaLocal from '../tabla/TablaLocal';
import { EMAIL_GROUPS } from '../../helpers/constants';

const selectEmailsByGroups = (grupo, alumno) => {
  const emailsSelectedes = grupo.map((g) => {
    let emailToSelect = '';

    switch (g.value) {
      case EMAIL_GROUPS.PERSONAL:
        emailToSelect = alumno.Email_personal;
        break;
      case EMAIL_GROUPS.CENTRO:
        emailToSelect = alumno.Email_Cedetec;
        break;
      case EMAIL_GROUPS.TUTOR1:
        emailToSelect = alumno.Tutor1_Mail;
        break;
      case EMAIL_GROUPS.TUTOR2:
        emailToSelect = alumno.Tutor2_Mail;
        break;
      default:
        break;
    }

    return emailToSelect === '-' ? '' : emailToSelect || '';
  });

  return emailsSelectedes;
};

const COLUMNAS = [
  { id: 'CODIGO', label: 'Código', width: 90, sortable: true, filter: 'text' },
  { id: 'SEDE', label: 'Sede', width: 120, sortable: true, filter: 'multi' },
  { id: 'NOMBRE_ALUMNO', label: 'Nombre', width: 160, sortable: true, filter: 'text' },
  { id: 'APELLIDOS', label: 'Apellidos', width: 200, sortable: true, filter: 'text' },
  { id: 'Email_Cedetec', label: 'Email Cedetec', width: 220, sortable: true, filter: 'text' },
  { id: 'Email_personal', label: 'Email Personal', width: 220, sortable: true, filter: 'text' },
  { id: 'Tutor1_Mail', label: 'Tutor 1 Email', width: 220, sortable: true, filter: 'text' },
  { id: 'Tutor2_Mail', label: 'Tutor 2 Email', width: 220, sortable: true, filter: 'text' },
  { id: 'DNI', label: 'DNI', width: 120, sortable: true, filter: 'text' },
];

const ListadoAlumnos = ({ alumnos, grupo, selectedEmails, setSelectedEmails }) => {
  useEffect(() => {
    if (!alumnos || alumnos.length === 0) {
      setSelectedEmails({});
      return;
    }

    setSelectedEmails((prevSelectedEmails) => {
      const newSelectedEmails = {};
      const alumnosSelecteds = alumnos.filter((a) =>
        Object.keys(prevSelectedEmails).includes(String(a.CODIGO)),
      );

      alumnosSelecteds.forEach((alumno) => {
        const emailsSelectedes = selectEmailsByGroups(grupo, alumno);
        newSelectedEmails[alumno.CODIGO] = emailsSelectedes;
      });

      return newSelectedEmails;
    });
  }, [alumnos, grupo, setSelectedEmails]);

  const seleccion = useMemo(
    () => ({
      estaSeleccionada: (alumno) =>
        Object.prototype.hasOwnProperty.call(selectedEmails || {}, String(alumno.CODIGO)),
      alternar: (alumno) => {
        if (!alumno.CODIGO) return;
        const key = String(alumno.CODIGO);
        setSelectedEmails((prev) => {
          const actualizado = { ...prev };
          if (Object.prototype.hasOwnProperty.call(actualizado, key)) {
            delete actualizado[key];
          } else {
            actualizado[key] = selectEmailsByGroups(grupo, alumno);
          }
          return actualizado;
        });
      },
      alternarTodas: (filas, marcar) => {
        setSelectedEmails((prev) => {
          const actualizado = { ...prev };
          filas.forEach((alumno) => {
            if (!alumno.CODIGO) return;
            const key = String(alumno.CODIGO);
            if (marcar) actualizado[key] = selectEmailsByGroups(grupo, alumno);
            else delete actualizado[key];
          });
          return actualizado;
        });
      },
    }),
    [selectedEmails, grupo, setSelectedEmails],
  );

  if (alumnos.length === 0) return null;

  return (
    <TablaLocal
      tablaKey="envio-mails"
      columnas={COLUMNAS}
      filas={alumnos}
      nombreEntidad="alumnos"
      archivo="envio-mails-alumnos"
      placeholder="Buscar alumno, código, DNI o email…"
      seleccion={seleccion}
      claveFila={(alumno) => alumno.CODIGO}
      tituloTarjeta={(alumno) =>
        `${alumno.NOMBRE_ALUMNO || ''} ${alumno.APELLIDOS || ''}`.trim() || String(alumno.CODIGO)
      }
    />
  );
};

ListadoAlumnos.propTypes = {
  alumnos: PropTypes.array.isRequired,
  grupo: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.string, label: PropTypes.string }))
    .isRequired,
  selectedEmails: PropTypes.object,
  setSelectedEmails: PropTypes.func,
};

export default ListadoAlumnos;
